<template>
  <div>
    <form @submit.stop.prevent="saveFiles()">
      <b-row>
        <b-col sm="12" md="12" lg="6" xl="6">
          <b-form-group label-size="md">
            <template slot="label">
              Type <span class="text-danger">*</span>
            </template>
            <b-form-select
              id="radio-group-2"
              v-model="form.type"
              name="radio-sub-component"
              :options="types"
              required
            >
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col
          v-if="form.type == 'titleFile' || form.type == 'titleFileOut'"
          xs="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
        >
          <b-form-group class="">
            <template slot="label"> Page type </template>
            <!-- group with radio buttons images  -->
            <b-row>
              <b-col cols="5">
                <b-form-radio
                  class="d-flex justify-content-between align-items-center"
                  v-model="form.pageType"
                  name="page-type-options"
                  :value="0"
                  >Single Page
                </b-form-radio>
                <b-form-radio
                  v-model="form.pageType"
                  name="page-type-options"
                  :value="1"
                  >Multi Page
                </b-form-radio>
              </b-col>

              <b-col
                cols=""
                class="d-flex justify-content-center align-items-center image-container"
              >
                <img
                  v-if="form.pageType === 0"
                  src="https://storagecanam.nyc3.cdn.digitaloceanspaces.com/Prod/system/1page.png"
                  alt="Single Page"
                  class="responsive-page-image"
                />
                <img
                  v-if="form.pageType === 1"
                  src="https://storagecanam.nyc3.cdn.digitaloceanspaces.com/Prod/system/2pages.png"
                  alt="Multi Page"
                  class="responsive-page-image"
                />
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group>
            <template slot="label">
              File <span class="text-danger">*</span>
            </template>
            <b-form-file
              id="file"
              v-model="form.file"
              accept=".pdf"
              required
              @change="validateFileSize"
              :state="fileValidation"
            />
            <b-form-invalid-feedback v-if="fileValidation === false">
              The file must be smaller than 20MB
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Stamp date 7501">
            <b-form-input
              v-model="form.stampDate7501"
              class="text-center"
              type="date"
            />
          </b-form-group>
        </b-col>

        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Received date">
            <b-form-input
              v-model="form.receivedDate"
              class="text-center"
              type="date"
            />
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group>
            <template slot="label"> Title Origin In </template>
            <multiselect
              v-model="form.titleOriginIn"
              :options="states"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="false"
              placeholder="Pick some option"
              label="name"
              track-by="name"
              :preselect-first="false"
            >
              <template slot="tag" slot-scope="{ option, remove }"
                ><span class="custom__tag"
                  ><span class="">{{ option.name }}</span
                  ><span class="ml-1 custom__remove" @click="remove(option)"
                    >❌</span
                  ></span
                ></template
              >
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            type="submit"
            variant="success"
            class="float-right"
            :disabled="
              !form.type || !form.file || titleFilesStatus == 'fetching'
            "
          >
            <!-- loader -->
            <b-spinner
              v-if="titleFilesStatus == 'fetching'"
              class="align-middle"
              variant="white"
            />
            <span v-else> Save </span>
          </b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { POST_TITLE_FILES } from "./actions";
import Multiselect from "vue-multiselect";

export default {
  name: "TitleManagerForm",
  components: {
    Multiselect,
  },
  props: {
    refreshData: {
      type: Function,
      required: true,
    },
    closeModal: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState({
      titleFilesStatus: (state) =>
        state.superAdminStore.titleManager.title.status,
      states: (state) =>
        state.superAdminStore.componentStore.exports.states.data,
    }),
  },
  data() {
    return {
      form: {
        type: null,
        file: null,
        stampDate7501: null,
        receivedDate: null,
        titleOriginIn: null,
        pageType: 0,
      },
      types: [
        { value: "file7501", text: "File 7501" },
        { value: "titleFile", text: "Title " },
        { value: "titleFileOut", text: "Title Reassigned" },
        { value: "sellContract", text: "Sell contract" },
        { value: "auctionSales", text: "Auction Sales" },
        { value: "stateLine", text: "State Line" },
      ],
      fileValidation: null,
      maxFileSize: 20 * 1024 * 1024, // 20MB en bytes
    };
  },
  mounted() {
    this.getStates();
  },

  methods: {
    saveFiles() {
      const payload = this.formatPayload();
      this.$store
        .dispatch(POST_TITLE_FILES, payload)
        .then(() => {
          this.resetForm();
          this.refreshData();
          this.closeModal();
          this.$bvToast.toast("Files uploaded successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          this.$bvToast.toast(error.data.message, {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },
    formatPayload() {
      const formData = new FormData();
      formData.set("type", this.form.type);
      formData.append("file", this.form.file);
      formData.set("stampDate7501", this.form.stampDate7501);
      formData.set("receivedDate", this.form.receivedDate);
      formData.set("titleOriginIn", this.form?.titleOriginIn?.name);
      if (this.form.type == "titleFile" || this.form.type == "titleFileOut") {
        formData.set("pageType", this.form.pageType);
      }

      return formData;
    },

    resetForm() {
      this.form = {
        type: null,
        file: null,
        stampDate7501: null,
        receivedDate: null,
        titleOriginIn: null,
      };
      this.fileValidation = null;
    },
    getStates() {
      this.$store.dispatch("GET_TITLE_ORIGIN").then(() => {});
    },

    validateFileSize(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > this.maxFileSize) {
          this.fileValidation = false;
          this.form.file = null;
          this.$bvToast.toast(
            `The file is too large. The maximum allowed size is ${
              this.maxFileSize / (1024 * 1024)
            }MB`,

            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
        } else {
          this.fileValidation = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.responsive-page-image {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 80px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.responsive-page-image:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.image-container {
  overflow: hidden;
  padding: 5px;
  min-height: 60px;
}

/* Ajustes responsive para diferentes tamaños de pantalla */
@media (min-width: 1200px) {
  .responsive-page-image {
    max-height: 100px;
  }
}

@media (max-width: 1199px) {
  .responsive-page-image {
    max-height: 70px;
  }
}

@media (max-width: 768px) {
  .responsive-page-image {
    max-height: 60px;
  }
}

@media (max-width: 576px) {
  .responsive-page-image {
    max-height: 50px;
  }
}
</style>
